import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Disable React Developer Tools
if (typeof window.__REACT_DEVTOOLS_GLOBAL_HOOK__ === 'object') {
  for (let key in window.__REACT_DEVTOOLS_GLOBAL_HOOK__) {
    window.__REACT_DEVTOOLS_GLOBAL_HOOK__[key] = typeof window.__REACT_DEVTOOLS_GLOBAL_HOOK__[key] === 'function' 
      ? () => {} 
      : null;
  }
}

// Remove React development overlay
if (typeof window !== 'undefined') {
  // Target React development overlay elements and remove them
  const removeReactOverlay = () => {
    const selectors = [
      'img[alt="React"]',
      'div[style*="position: fixed; z-index: 9999;"]',
      'div[style*="padding: 4px 8px; background-color"]',
      'div[style*="background: rgb(40, 44, 52);"]',
      'div[style*="right: 0px; bottom: 0px;"]',
      'iframe[style*="position: fixed;"]',
      '*[style*="position: fixed"] img'
    ];
    
    selectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(el => {
        if (el && el.parentNode) {
          el.parentNode.removeChild(el);
        }
      });
    });

    // Additional specific check for the React logo
    const allImages = document.querySelectorAll('img');
    allImages.forEach(img => {
      if (img.alt === 'React' || 
          (img.src && img.src.includes('react')) || 
          (img.parentNode && 
           img.parentNode.style && 
           img.parentNode.style.position === 'fixed')) {
        if (img.parentNode) {
          img.parentNode.removeChild(img);
        }
      }
    });

    // Remove the parent container if it exists
    const fixedDivs = document.querySelectorAll('div[style*="position: fixed"]');
    fixedDivs.forEach(div => {
      const images = div.querySelectorAll('img');
      if (images.length > 0 && div.parentNode) {
        div.parentNode.removeChild(div);
      }
    });
  };

  // Run immediately and periodically check
  removeReactOverlay();
  setInterval(removeReactOverlay, 200);
  
  // Also run when DOM is loaded
  document.addEventListener('DOMContentLoaded', removeReactOverlay);
  window.addEventListener('load', removeReactOverlay);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
